export const MAX_MODULES_PER_PAGE = 25;
export const MAX_MODULES_PER_PAGE_SECTION = 15;
export const MAX_MANUAL_DISCLOSURES_PER_PAGE = 5;

// Do not add to this list unless it is present in every PageModel.
export const COMMON_PAGE_SECTIONS = ['nav', 'hero', 'modulesCollection', 'footer', 'disclosures'] as const;
